import React, { useState, useEffect } from 'react';

function Receipt() {
  return (
    <div className='d-inline-block px-2'>
      <h1>Receipt</h1>
    </div>
  );
}

export default Receipt;
